module.exports = __webpack_public_path__ + "img/Flag_of_Côte_d'Ivoire.e2ead7af.svg";